import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useUsersAndGroupsLdFlags = createFlagsHook<typeof import('./flags.json')>()
